<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

    <p-toast position="top-right"></p-toast>

    <service-type-promotions-detail [showSideBar]="showSideBar" [_promoId]="selectPromoId"
                                    [serviceTypePromotionsComponent]="this"
                                    (changedShowSideBarEmit)="changedShowSideBarEmit($event)"></service-type-promotions-detail>

    <service-type-promotion-add-update *ngIf="showAddEditPromotionSideBar"
                                       [_promoId]="selectPromoId"
                                       [_promoTypeId]="selectPromoTypeId"
                                       [_showAddEditPromotionSideBar]="showAddEditPromotionSideBar"
                                       [serviceTypePromotionsComponent]="this"
                                       (changedShowAddEditPromotionSideBarEmit)="changedShowAddEditPromotionSideBarEmit($event)"></service-type-promotion-add-update>

    <service-type-promotion-filter *ngIf="visiblePartnerMarketingFilterPromotion"
                                   [visiblePartnerMarketingFilterPromotion]="visiblePartnerMarketingFilterPromotion"
                                   [serviceTypePromotionsComponent]="this"
                                   [_filterObj]="filter"
                                   (changedShowPartnerMarketingFilterPromotionSideBarEmit)="changedShowPartnerMarketingFilterPromotionSideBarEmit($event)"></service-type-promotion-filter>

    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>

    <div class="card">
        <!-- Table -->
        <p-table #promosGrid
                 [columns]="cols"
                 [value]="promos"
                 [lazy]="true"
                 responsiveLayout="scroll" dataKey="Id"
                 (onLazyLoad)="handlePromoLazyLoad($event)"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [rowsPerPageOptions]="rowsPerPageOptions"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [style]="{height: 'calc(80vh)'}">
            <ng-template pTemplate="caption">
                <div class="flex flex-row sp-header">
                    <div class="sp-header__col-left">
                        <div class="sp-header__title">All Promotions</div>
                    </div>
                    <div class="flex flex row sp-header__col-right">
                        <div class="ml-20">
                            <button class="white-btn-filter" pButton label="Filter" (click)="openPartnerMarketingFilterPromotionSideBar()"></button>
                        </div>
                        <div class="ml-20">
                            <button class="bluedark-btn-filter" pButton label="Create Promotion" (click)="openMerchantCreatePromotionSideBar()"></button>
                        </div>
                        <div class="ml-3 mt-2 mr-2">
                            <column-selector #columnSelector
                                 [defaultColumns]="defaultCols"
                                 (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                 [tableName]="tableName"
                                 [(selectedColumns)]="cols">
                            </column-selector>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon *ngIf="col.showSortIcon !== false" [field]="col.field"></p-sortIcon>
                    </th>
                    <th>Action</th>
                </tr>
                <tr>
                    <ng-container *ngFor="let promo of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="promo.fieldType === fieldTypeEnum.Inputs">
                                <input type="text" pInputText placeholder="{{promo.placeholder}}" [(ngModel)]="filter[promo.model]"
                                       (input)="handleHeaderFilterChange()" />
                            </ng-container>
                            <ng-container *ngIf="promo.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{promo.placeholder}}" [(ngModel)]="filter[promo.model]"
                                               (ngModelChange)="handleHeaderFilterChange()"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="promo.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="promo.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="promo.options" placeholder="{{promo.placeholder}}"
                                                optionLabel="name" [(ngModel)]="filter[promo.model]"
                                                (ngModelChange)="handleHeaderFilterChange()"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="promo.options" placeholder="{{promo.placeholder}}"
                                                optionLabel="name" optionValue="id" [(ngModel)]="filter[promo.model]"
                                                (ngModelChange)="handleHeaderFilterChange()"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="promo.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="filter[promo.model]"
                                            [showIcon]="true"
                                            placeholder="{{promo.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleHeaderFilterChange()" />
                            </ng-container>
                            <ng-container *ngIf="promo.fieldType === fieldTypeEnum.CalendarTime">
                                <p-calendar [(ngModel)]="filter[promo.model]"
                                            [timeOnly]="true"
                                            [showIcon]="true"
                                            hourFormat="12"
                                            placeholder="{{promo.placeholder}}"
                                            (ngModelChange)="handleHeaderFilterChange()" />
                            </ng-container>
                        </th>
                    </ng-container>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-promo>
                <tr>
                    <td *ngFor="let col of cols" [pSelectableRow]="promo" class="ui-resizable-column">
                        <ng-container *ngIf="col.field === 'IsActive'">
                            <div class="flex flex-row">
                                <div>
                                    <p-inputSwitch [(ngModel)]="promo.IsActive" (onChange)="switchPromo(promo)"></p-inputSwitch>
                                </div>
                                <div class="table-col-item-isactive">
                                    <span *ngIf="promo.IsActive" class="table-col-item-isactive__active">Active</span>
                                    <span *ngIf="!promo.IsActive" class="table-col-item-isactive__notactive">Inactive</span>
                                </div>
                            </div>
                        </ng-container>
                        
                        <ng-container *ngIf="col.field === 'StartedAt'">
                            {{promo.StartedAtStr}}
                        </ng-container>

                        <ng-container *ngIf="col.field === 'ValidUntil'">
                            {{promo.ValidUntilStr}}
                        </ng-container>
                        
                        <ng-container *ngIf="col.field !== 'IsActive' && col.field !== 'Status' && col.field !== 'StartedAt' && col.field !== 'ValidUntil'">
                            {{promo[col.field]}}
                        </ng-container>

                        <ng-container *ngIf="col.field === 'Status'">
                            <div class="promo-status" [class]="getPromoStatusStyle(promo.StartedAt, promo.ValidUntil)" >{{getPromoStatus(promo.StartedAt, promo.ValidUntil)}}</div>
                        </ng-container>
                    </td>
                    <td class="ui-resizable-column">
                        <!--                        <span class="action-icon-svg" (click)="handleDetailPopupClick(promo)">-->
                        <!--                            <img src="../Content/xpress-app/images/svg/icon_view.svg" />-->
                        <!--                        </span>-->
                        <span class="action-icon-svg" (click)="showModalSideBarAddUpdate(promo)">
                                <img src="../Content/xpress-app/images/svg/icon_edit.svg" />
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="promos !== null && promos.length > 0" style="padding-left: 10px">
                    Displaying {{first + 1}} - {{first + promos.length}} of {{totalRecords}}
                </div>
            </ng-template>
        </p-table>
    </div>
</div>
